// @flow

import ExtendableError from 'es6-error';
import type {
  GuidePayloadType
} from './types';

export class GuideError extends ExtendableError {}

export class InvalidGuideError extends GuideError {
  // eslint-disable-next-line no-unused-vars
  constructor (guide: string) {
    super('The input GUIDE cannot be decrypted.');
  }
}

export class UnexpectedNamespaceValueError extends InvalidGuideError {
  // eslint-disable-next-line no-unused-vars
  constructor (guide: string, expectedNamespace: string, expectedResourceTypeName: string, payload: GuidePayloadType) {
    super(guide);

    this.message = 'Decrypted GUIDE namespace does not match the expected namespace.';
  }
}

export class UnexpectedResourceTypeNameValueError extends InvalidGuideError {
  // eslint-disable-next-line no-unused-vars
  constructor (guide: string, expectedNamespace: string, expectedResourceTypeName: string, payload: GuidePayloadType) {
    super(guide);

    this.message = 'Decrypted GUIDE resource type name does not match the expected resource type name.';
  }
}
